import { DirectiveOptions } from "vue";

export const Draggable: DirectiveOptions = {
    unbind: function (el:any,binding) {
        document.removeEventListener('mousemove', el.dragModal);
        document.removeEventListener('mouseup', el.stopDragging);
    },
    inserted: function (el:any,binding) {
    // Focus the element
    console.log(binding)
    let dragHandler:any=document.getElementById(binding.value);
    if (!dragHandler){
        return
    }
    dragHandler.addEventListener("mousedown", startDragging);
    let offsetX:any=undefined;
    let offsetY:any=undefined;
    let modalLeft:any=undefined;
    let modalTop:any=undefined;
    let isDragging=false;
    document.addEventListener('mousemove', dragModal);
    document.addEventListener('mouseup', stopDragging);
    function stopDragging() {
        isDragging = false;
        //this.storePosition();
    }
    el.dragModal=dragModal;
    el.stopDragging=stopDragging;
    function dragModal(event: MouseEvent) {
        if (isDragging) {
        //const mainMap = document.getElementById(this.mapId);
        //if (!mainMap) return;
        //const mainMapRect = mainMap.getBoundingClientRect();
        const mainMapRect = document.body.getBoundingClientRect();       
        // Calcul de la nouvelle position en fonction de la position initiale du curseur et de l'élément
        const newLeft = Math.min(
            Math.max(mainMapRect.left, event.clientX - offsetX),
            mainMapRect.right - el.clientWidth
        );
        const newTop = Math.min(
            Math.max(mainMapRect.top, event.clientY - offsetY),
            mainMapRect.bottom - el.clientHeight
        );

        // Ajustement de la position en tenant compte de la différence initiale entre la souris et l'élément
        modalLeft = newLeft - mainMapRect.left;
        modalTop = newTop - mainMapRect.top;
        el.style.position="fixed"
        el.style.left=`${modalLeft}px`;
        el.style.top=`${modalTop}px`;
        }
    }
    function startDragging (event: MouseEvent) {
        const rect = el.getBoundingClientRect();
        offsetX = event.clientX - rect.left;
        offsetY = event.clientY - rect.top;
        isDragging = true;
        
  }
  },
  
}